import MainPage from "./views/main";
import FilterPage from "./views/history";
import LivePage from "./views/live";

const RouteList = [
  /* Dashboard */
  {
    exact: true,
    path: "/",
    name: "Home",
    component: MainPage,
  },
  {
    exact: true,
    path: "/ket-qua-xo-so/:date",
    name: "ket-qua-xo-so",
    component: FilterPage,
  },
  {
    exact: true,
    path: "/xo-so-truc-tiep/mien-nam.html",
    name: "live-page",
    component: LivePage,
  }
];

export default RouteList;
